// extracted by mini-css-extract-plugin
module.exports = {"field":"MiniData_field__1AmWk","checkbox":"MiniData_checkbox__2Kp9z"};